export const FieldsBehaviour = {
  text: {
    behaviouralRuleType: "text",
    config: {}
  },
  textarea: {
    behaviouralRuleType: "text",
    config: {}
  },
  email: {
    behaviouralRuleType: "text",
    config: {}
  },
  phone: {
    behaviouralRuleType: "text",
    config: {}
  },
  integer: {
    behaviouralRuleType: "number",
    config: {}
  },
  number: {
    behaviouralRuleType: "number",
    config: {}
  },
  decimal: {
    behaviouralRuleType: "number",
    config: {
      decimals: null,
      max_digits: null
    }
  }
}